module.exports = __webpack_public_path__ + "src/assets/games/29/333.jpg";